import React from "react";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import CabinetDialog from "../modelDialogs/CabinetDialog";
import BaseModelMap from "../models/BaseModelMap";
import Cabinet from "../models/Cabinet";
import TreeViewModel from "../models/TreeviewModel";
import BaseModel from "../models/BaseModel";
import Logger from "../Logger";

const logger = new Logger();

export default class CabinetsTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<Cabinet> {
    return this.obj as BaseModelMap<Cabinet>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    return this.typedObj.sortBy("tagOrName");
  }

  handleAdd() {
    state.dialogManager.openDialog(<CabinetDialog parent={this.typedObj} />);
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] | undefined {
    return [this.inlineButton_Add("ContextMenuLables.addCabinet")]; // no itx
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////////

  canBePastedInteractive(copiedObjClassName: string): boolean {
    if (copiedObjClassName == "Cabinet") {
      return true;
    }
    return false;
  }

  async getDisabledContextMenuItems(): Promise<Array<string>> {
    const copiedObjClassName = state.clipboard.getClassName();

    if (copiedObjClassName == "Cabinet") {
      return new Array<string>();
    }

    return ["paste"]; // no itx
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      items: [
        this.baseContextMenuItems_Paste(subLabelPaste),
        this.baseContextMenuItems_Add("ContextMenuLables.addCabinet"), // no itx
      ],
    };
  }
}
